<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    // if (icon) {
    //   vnodes.push(<svg-icon icon-class={icon}/>)
    // }
    //
    // if (title) {
    //   vnodes.push(<span slot='title'>{(title)}</span>)
    // }
    if(icon.indexOf('-') === -1){
      vnodes.push(<svg-icon icon-class={icon}/>)
    }else {
      vnodes.push(<i class= {'class_el '+icon}/>)
    }

    vnodes.push(<span slot='title'>{(title)}</span>)
    return vnodes
  }
}
</script>
<style lang="scss">
  .el-submenu__title .class_el{
    color: rgb(191, 203, 217);
    font-size: 16px;
    margin-right: 16px;
  }
  #app .sidebar-container .is-active > .el-submenu__title .class_el{
    color: #f4f4f5;
  }
  #app .hideSidebar .el-submenu > .el-submenu__title .class_el{
    margin-left: 20px;
  }
</style>
